import MuiAlert from './MuiAlert';
import MuiButton from './MuiButton';
import MuiCard from './MuiCardContent';
import MuiCheckbox from './MuiCheckbox';
import MuiChip from './MuiChip';
import MuiCircularProgress from './MuiCircularProgress';
import MuiCssBaseline from './MuiCssBaseline';
import MuiDataGrid from './MuiDataGrid';
import MuiDialog from './MuiDialog';
import MuiDialogActions from './MuiDialogActions';
import MuiDialogContent from './MuiDialogContent';
import MuiDialogTitle from './MuiDialogTitle';
import MuiFormControlLabel from './MuiFormControlLabel';
import MuiFormLabel from './MuiFormLabel';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiInputLabel from './MuiInputLabel';
import MuiLink from './MuiLink';
import MuiMenuItem from './MuiMenuItem';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPickersOutlinedInput from './MuiPickersOutlinedInput';
import MuiRadio from './MuiRadio';
import MuiSnackbarContent from './MuiSnackbarContent';
import MuiSvgIcon from './MuiSvgIcon';
import MuiTextField from './MuiTextField';
import MuiTooltip from './MuiTooltip';
import MuiTypography from './MuiTypography';

import type { Components, Theme } from '@mui/material/styles';

export default function buildComponents(theme: Theme): Components {
  return {
    MuiCssBaseline: MuiCssBaseline(theme),
    MuiTypography: MuiTypography(theme),
    MuiButton: MuiButton(theme),
    MuiFormControlLabel: MuiFormControlLabel(theme),
    MuiFormLabel: MuiFormLabel(theme),
    MuiInputLabel: MuiInputLabel(theme),
    MuiInputBase: MuiInputBase(theme),
    MuiOutlinedInput: MuiOutlinedInput(theme),
    MuiPickersOutlinedInput: MuiPickersOutlinedInput(theme),
    MuiTextField: MuiTextField(theme),
    MuiCheckbox: MuiCheckbox(theme),
    MuiLink: MuiLink(theme),
    MuiSvgIcon: MuiSvgIcon(theme),
    MuiCircularProgress: MuiCircularProgress(theme),
    MuiDataGrid: MuiDataGrid(theme),
    MuiSnackbarContent: MuiSnackbarContent(theme),
    MuiAlert: MuiAlert(theme),
    MuiDialog: MuiDialog(theme),
    MuiDialogContent: MuiDialogContent(theme),
    MuiDialogActions: MuiDialogActions(theme),
    MuiDialogTitle: MuiDialogTitle(theme),
    MuiMenuItem: MuiMenuItem(theme),
    MuiCard: MuiCard(theme),
    MuiRadio: MuiRadio(theme),
    MuiTooltip: MuiTooltip(theme),
    MuiChip: MuiChip(theme),
    MuiIconButton: MuiIconButton(theme),
  };
}
